import { format } from 'date-fns';
import { useEffect } from 'react';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui/Stack';
import { AggregateMetricsTimePeriod } from 'src/WebApiController';

import { SaleChartData, useDataInsights } from '../DataInsightsContext';

interface ChartTooltipProps {
  label: string;
  payload: Record<string, any>[] | undefined;
  setCurrMarketshare: React.Dispatch<
    React.SetStateAction<SaleChartData | null>
  >;
}

export const MarketshareTooltip = ({
  payload,
  setCurrMarketshare,
}: ChartTooltipProps) => {
  const { timePeriod } = useDataInsights();

  const hourlyTimestamp =
    timePeriod === AggregateMetricsTimePeriod.Today ||
    timePeriod === AggregateMetricsTimePeriod.LastWeek;
  useEffect(() => {
    if (payload && payload.length > 0) {
      setCurrMarketshare(payload[0].payload);
    }
  }, [payload, setCurrMarketshare]);

  if (!payload || payload.length === 0) {
    return null;
  }
  const safeDateTime = `${payload[0].payload.dateTime}:00:00`; // normalize to 'YYYY-MM-DDTHH:MM:SS'

  return (
    <div
      style={{
        color: vars.color.textPrimary,
        fontSize: vars.typography.fontSize.xs,
        textAlign: 'center',
        backgroundColor: vars.color.backgroundPrimary,
        height: '16p',
        borderRadius: '4px',
        padding: '8px',
        zIndex: 100,
      }}
    >
      <Stack direction="column" alignItems="center">
        <span>
          {format(
            new Date(safeDateTime),
            hourlyTimestamp ? 'MMM dd, yyyy hh:mm a' : 'MMM dd, yyyy'
          )}
        </span>
      </Stack>
    </div>
  );
};
